var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"row",attrs:{"name":"invasions-list","tag":"div"}},_vm._l((_vm.invasions),function(invasion){return _c('invasion-card',{key:invasion.id,staticClass:"invasions-list-item",attrs:{"invasion":invasion}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }